import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/homeData';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Aerial%20drone%20view%20of%20a%20heart%20shaped%20tropical%20island%20with%20white%20sand%20beaches%20surrounded%20by%20crystal%20clear%20turquoise%20water%2C%20lush%20green%20palm%20trees%20in%20the%20center%2C%20bright%20sunny%20day%20with%20gentle%20clouds%2C%20paradise%20destination%2C%20professional%20aerial%20photography%2C%20stunning%20natural%20beauty%20composition&width=1800&height=600&seq=cta-romantic-2026&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/60"></div>

      <div className="relative z-10 container-wide text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-background-50 mb-4">
          准备好开启你们的浪漫之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/85 max-w-lg mx-auto mb-8">
          现在就联系我们，让{siteInfo.name}为你们定制专属的甜蜜行程
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="tel:4008886688"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap"
          >
            立即咨询
          </a>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm backdrop-blur-sm border border-background-50/20 transition-all duration-200 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}